import { pdfjs } from "react-pdf";
import { electronAppPath } from "../../App";

const getWorkerScriptPath = () => {
  if (!!window?.electronAPI) {
    const path = require("path");
    // Running in Electron, load the worker script from the local file system
    return `file://${path.join(
      __dirname,
      electronAppPath ? electronAppPath() : "",
      "dist",
      "static",
      "js",
      "pdf.worker.min.js"
    )}`;
  } else {
    // Running in a web browser, load the worker script from the CDN
    return `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  }
};

export default getWorkerScriptPath;
